import { useQuery } from '@tanstack/react-query'
import { QUERY_TIME_CONFIG } from '@omnea-app/fe-api-client/queryConfig'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const useGetPauseReasons = () => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: ['pause-reasons'],
    staleTime: QUERY_TIME_CONFIG.REFERENCE_DATA_STALE_TIME,
    queryFn: async () => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })

      const { data, error } = await apiClient.GET('/pause-reasons')

      throwIfApiError(error)

      return data
    },
  })
}
